<template>
	<vx-card no-shadow card-border :title="$t('Routing.Table.Identification') + ' : ' + selectedInfoDetails">
		<!-- NAV BAR VISIT POINT -->
		<vs-navbar :type="'border'" v-model="activeItem" class="nabarx mb-5" square>
			<div slot="title">
				<vs-navbar-title>
					<span class="text-primary">
						{{ $t("RouterSelection.Total") + " " + $t("VisitsWithErrors") + ":" }}
						{{ visit_point_selected != null ? visit_point_selected.length : 0 }}
					</span>
				</vs-navbar-title>
			</div>
			<vs-navbar-item index="1">
				<vx-tooltip
					class="cursor-pointer"
					style="z-index: 99999"
					color="primary"
					position="bottom"
					delay=".1s"
					:title="$t('Routing.CreateVisitPoint.BulkAssign') + ' ' + $t('Resource')"
					:text="$t('ResourceModule.AssigResources')"
				>
					<a href="#" @click="activePromptResource = true" class="text-center"
						><feather-icon class="cursor-pointer" icon="UsersIcon" /><br /><small>{{
							$t("ResourceModule.AssigResources")
						}}</small></a
					>
				</vx-tooltip>
			</vs-navbar-item>
			<vs-navbar-item index="2">
				<vx-tooltip
					class="cursor-pointer"
					style="z-index: 99999"
					color="primary"
					position="bottom"
					delay=".1s"
					:title="$t('Routing.Title.AssignBulkActivity')"
					:text="$t('Routing.Title.AssignActivity')"
				>
					<a href="#" @click="activePrompt = true" class="text-center"
						><feather-icon class="cursor-pointer" icon="TagIcon" /><br /><small>{{
							$t("RouterSelection.AssignActivities")
						}}</small></a
					>
				</vx-tooltip>
			</vs-navbar-item>
			<vs-navbar-item index="3">
				<vx-tooltip
					class="cursor-pointer"
					style="z-index: 99999"
					color="primary"
					position="bottom"
					delay=".1s"
					:title="$t('Routing.CreateVisitPoint.BulkAssign') + ' ' + $t('VisitPoint')"
					:text="$t('VisitPoints.AssignVisitPoints')"
				>
					<a href="#" @click="activePromptVisitPoint = true" class="text-center"
						><feather-icon class="cursor-pointer" icon="MapPinIcon" /><br /><small>{{
							$t("VisitPoints.AssignVisitPoints")
						}}</small></a
					>
				</vx-tooltip>
			</vs-navbar-item>
		</vs-navbar>
		<vue-perfect-scrollbar class="scroll-area" :settings="settings">
			<vs-list>
				<list-selected-datarutas-visit-points-item
					:key="index"
					v-for="(visitPoint, index) in visit_point_selected"
					:visit_point_selected="visitPoint"
					:indexVisitPoint="index + 1"
					:activityOptions="activityOptions"
					:activitySelected="selectedActivityItems"
					:visitPointSelected="selectedVisitPointItems"
					:resourceSelected="selectedResourceItems"
					:visitPointOptions="visitPointOptions"
					:resourceOptions="resourceOptions"
				></list-selected-datarutas-visit-points-item>
			</vs-list>
		</vue-perfect-scrollbar>

		<vs-prompt
			style="z-index: 54000"
			:title="$t('Routing.Title.AssignBulkActivity')"
			:active.sync="activePrompt"
			:acceptText="$t('Accept')"
			:cancelText="$t('Cancel')"
			@cancel="closePrompt"
			@accept="acceptPrompt"
			@close="closePrompt"
		>
			<div class="con-exemple-prompt">
				<div class="mt-1">
					<form>
						<label class="vs-input--label">{{ $t("Activity") }}</label>
						<v-select
							v-model="selectedActivity"
							:clearable="false"
							:options="activityOptions"
							v-validate="'required'"
							name="role"
						>
							<template v-slot:no-options="{search, searching}">
								<template v-if="searching">
									{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
								</template>
								<template v-else>
									{{ $t("NoResultsFound") }}
								</template>
							</template>
						</v-select>
						<span class="text-danger text-sm" v-show="false">{{ $t("MODULE_ROLE.SelectRole") }}</span>
					</form>
				</div>
			</div>
		</vs-prompt>
		<vs-prompt
			style="z-index: 54000"
			:title="$t('Routing.CreateVisitPoint.BulkAssign') + ' ' + $t('Resource')"
			:active.sync="activePromptResource"
			:acceptText="$t('Accept')"
			:cancelText="$t('Cancel')"
			@cancel="closePrompt"
			@accept="acceptPromptResource"
			@close="closePrompt"
		>
			<div class="con-exemple-prompt">
				<div class="mt-1">
					<form>
						<div class="vx-col w-full my-1">
							<label class="vs-input--label">{{ $t("SearchResourceBy") }}</label>
							<v-select
								v-model="searchFieldSelected"
								v-validate="'required'"
								name="selectedResource"
								:clearable="false"
								:options="searchOptions"
								:dir="$vs.rtl ? 'rtl' : 'ltr'"
								:disabled="resourceOptions.length === 0"
							>
								<template v-slot:no-options="{search, searching}">
									<template v-if="searching">
										{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
									</template>
								</template>
							</v-select>
						</div>
						<div class="vx-col w-full my-1">
							<label class="vs-input--label">{{ $t("Resources") }}</label>
							<v-select
								name="resource"
								class="select-large"
								v-model="selectedResource"
								:clearable="false"
								:options="resourceOptions"
								:dir="$vs.rtl ? 'rtl' : 'ltr'"
								:disabled="resourceOptions.length === 0"
							>
								<template v-slot:no-options="{search, searching}">
									<template v-if="searching">
										{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
									</template>
								</template>
								<template #option="{username, label}">
									{{ username }}
									<br />
									<cite v-if="searchField !== 'username'" style="font-size: 12px">{{ label }}</cite>
								</template>
							</v-select>
						</div>
					</form>
				</div>
			</div>
		</vs-prompt>
		<vs-prompt
			style="z-index: 54000"
			:title="$t('Routing.CreateVisitPoint.BulkAssign') + ' ' + $t('VisitPoint')"
			:active.sync="activePromptVisitPoint"
			:acceptText="$t('Accept')"
			:cancelText="$t('Cancel')"
			@cancel="closePrompt"
			@accept="acceptPromptVisitPoint"
			@close="closePrompt"
		>
			<div class="con-exemple-prompt">
				<div class="mt-1">
					<form>
						<div class="vx-col w-full my-1">
							<label class="vs-input--label">{{ $t("SearchVisitPointBy") }}</label>
							<v-select
								v-model="searchFieldSelectedVisitPoint"
								v-validate="'required'"
								name="selectedResource"
								:clearable="false"
								:options="searchOptionsVisitPoint"
								:dir="$vs.rtl ? 'rtl' : 'ltr'"
								:disabled="visitPointOptions.length === 0"
							>
								<template v-slot:no-options="{search, searching}">
									<template v-if="searching">
										{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
									</template>
								</template>
							</v-select>
						</div>
						<div class="vx-col w-full my-1">
							<label class="vs-input--label">{{ $t("VisitPoint") }}</label>
							<v-select
								name="visitpoint"
								class="select-large"
								v-model="selectedVisitPoint"
								:clearable="false"
								:options="visitPointOptions"
								:dir="$vs.rtl ? 'rtl' : 'ltr'"
								:disabled="visitPointOptions.length === 0"
							>
								<template v-slot:no-options="{search, searching}">
									<template v-if="searching">
										{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
									</template>
								</template>
								<template #option="{name, label}">
									{{ name }}
									<br />
									<cite v-if="searchFieldVisitPoint !== 'name'" style="font-size: 12px">{{
										label
									}}</cite>
								</template>
							</v-select>
						</div>
					</form>
				</div>
			</div>
		</vs-prompt>
	</vx-card>
</template>

<script>
import vSelect from "vue-select";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Api from "@/helpers/api.js";
import ListSelectedDatarutasVisitPointsItem from "./ListSelectedDatarutasVisitPointsItem.vue";
import moduleOptimization from "@/store/optimization/moduleOptimization.js";

export default {
	components: {
		vSelect,
		VuePerfectScrollbar,
		ListSelectedDatarutasVisitPointsItem,
	},
	props: {
		visit_point_selected: {
			type: Array,
			default: () => [],
		},
		selectedInfoDetails: "",
	},
	data() {
		return {
			isMounted: false,
			selectedResourcesFormat: [],
			activePrompt: false,
			activePromptResource: false,
			activePromptVisitPoint: false,
			activitiesList: [],
			resourceList: [],
			visitPointList: [],
			selectedActivity: {label: this.$t("Select"), value: null},
			selectedActivityItems: {label: this.$t("Select"), value: null},
			selectedResource: {label: this.$t("Select"), value: null},
			selectedResourceItems: {label: this.$t("Select"), value: null},
			selectedVisitPoint: {label: this.$t("Select"), value: null},
			selectedVisitPointItems: {label: this.$t("Select"), value: null},
			searchFieldSelected: {value: "username", label: this.$t("Username")},
			searchFieldSelectedVisitPoint: {value: "name", label: this.$t("Name")},
			searchField: "username",
			searchFieldVisitPoint: "id",
			selectedResourceInfo: null,
			activePromptResourceInfo: false,
			activeItem: 1,
			quantityElementPage: 1000000,
			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			resourceListConfig: {
				rowSelection: "single",
				activeCheckbox: true,
				columns: ["identification", "name", "lastname", "username", "demand", "email", "alias", "status"],
				actionDropdown: false,
				btnAssigResources: true,
				popupMode: true,
				activeHeaderCheckboxSelection: true,
				tableOptions: false,
				CellRendererDemand: false,
				showItemsPerPage: false,
				showBtnNewResource: false,
				showSelectedResource: true,
				showPopup: true,
			},
		};
	},
	watch: {
		searchFieldSelected(val) {
			this.searchField = val.value;
		},
		searchFieldSelectedVisitPoint(val) {
			this.searchFieldVisitPoint = val.value;
		},
		activeItem(val) {
			if ((val == "2" || val == "3") && this.visit_point_selected[0].resource_id === null) {
				this.$vs.notify({
					color: "warning",
					title: this.$t("Routing.CreateVisitPoint.BulkAssign"),
					text: this.$t("ToAssignAnActivityOrVisitPoint"),
					time: 7000,
				});
				this.activePrompt = false;
				this.activePromptVisitPoint = false;
				this.activeItem = 1;
			}
		},
	},
	computed: {
		activityOptions() {
			return this.activitiesList.map((el) => {
				return {
					value: el.id,
					label: el.id + " - " + el.name,
				};
			});
		},
		resourceOptions() {
			return this.resourceList.map((resource) => {
				return {
					username: resource["username"],
					label: resource[this.searchField],
					value: resource.id,
					idAndName: resource.id + " - " + resource.name + " " + resource.lastname,
				};
			});
		},
		visitPointOptions() {
			return this.visitPointList.map((visitpoint) => {
				return {
					name: visitpoint.name,
					label: visitpoint[this.searchFieldVisitPoint] + " - " + visitpoint.name,
					value: visitpoint.id,
					idAndName: visitpoint.id + " - " + visitpoint.name,
				};
			});
		},
		iconSize() {
			return this.$store.state.windowWidth < 620 ? "small" : "medium";
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		searchOptions() {
			return [
				{value: "id", label: "Id"},
				{value: "name", label: this.$t("Name")},
				{value: "lastname", label: this.$t("ResourceModule.Table.Lastname")},
				{value: "username", label: this.$t("Username")},
				{value: "email", label: this.$t("Email")},
			];
		},
		searchOptionsVisitPoint() {
			return [
				{value: "id", label: "Id"},
				{value: "name", label: this.$t("Name")},
				{value: "address", label: this.$t("ResourceModule.Table.Address")},
				{value: "city", label: this.$t("ResourceModule.Table.City")},
			];
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		acceptPrompt() {
			this.setVisitPointActivity(this.selectedActivity);
		},
		acceptPromptResource() {
			this.setResourceId(this.selectedResource);
		},
		acceptPromptVisitPoint() {
			this.setVisitPointId(this.selectedVisitPoint);
		},
		closePrompt() {},
		getDatarutasActivities(id = null) {
			const payload = {
				page: 1,
				fields: [],
				quantity: this.quantityElementPage,
				sort: "DESC",
				order_by: ["id"],
			};
			if (id != null) payload.resource_id = [id];
			Api.post("/datarutas/activity", payload)
				.then((res) => {
					this.activitiesList = res.data.records;
				})
				.catch((err) => {
					console.error(err);
				});
		},
		async getVehiclesDatarutas(page) {
			const payload = {
				page,
				quantity: this.quantityElementPage,
				role_name: ["EXECUTIVE", "SUPERVISOR"],
				match_filter: !this.isExactly,
				sort: "desc",
				order_by: ["id"],
			};
			await this.$store
				.dispatch("vehicle/fetchDatarutasResource", payload)
				.then((res) => {
					this.resourceList = res.records;
				})
				.catch((err) => {
					console.error(err);
				});
		},
		async getVisitPointDatarutas(id = null) {
			const payload = {
				resource_id: id != null ? [id] : [],
				sort: "desc",
				order_by: ["id"],
			};
			await this.$store
				.dispatch("moduleVisitPoint/findVisitPointPaginatedDatarutas", payload)
				.then((res) => {
					this.visitPointList = res.records;
				})
				.catch((err) => console.error(err));
		},
		setVisitPointActivity(selectedActivity) {
			const foundAct = this.activitiesList.find((e) => e.id === selectedActivity.value);
			if (foundAct) {
				this.visit_point_selected.map((v) => {
					v.activity_id = foundAct.id;
					this.selectedActivityItems = {label: foundAct.id + " - " + foundAct.name, value: foundAct.id};
					return v;
				});
			}
		},
		setResourceId(resource) {
			const foundAct = this.resourceList.find((e) => e.id === resource.value);
			if (foundAct) {
				this.visit_point_selected.map((v) => {
					v.resource_id = foundAct.id;
					this.selectedResourceItems = {label: foundAct.name, value: foundAct.id};
					return v;
				});
				this.getDatarutasActivities(resource.value);
				this.getVisitPointDatarutas(resource.value);
			}
		},
		setVisitPointId(visitpoint) {
			const foundAct = this.visitPointList.find((e) => e.id === visitpoint.value);
			if (foundAct) {
				this.visit_point_selected.map((v) => {
					v.visit_point_id = foundAct.id;
					this.selectedVisitPointItems = {label: foundAct.id + " - " + foundAct.name, value: foundAct.id};
					return v;
				});
			}
		},
	},
	mounted() {
		this.isMounted = true;
	},
	created() {
		if (!moduleOptimization.isRegistered) {
			this.$store.registerModule("moduleOptimization", moduleOptimization);
			moduleOptimization.isRegistered = true;
		}
		this.getVehiclesDatarutas();
		this.getDatarutasActivities(this.visit_point_selected[0].resource_id);
		this.getVisitPointDatarutas(this.visit_point_selected[0].resource_id);
	},
};
</script>

<style lang="scss" scoped>
#content-router-selection {
	height: 100%;
}

.scroll-area {
	margin: auto;
	width: 100%;
	min-height: 550px;
	max-height: 500px;
}
.content-form-create {
	width: 100%;
	min-height: 550px;
	max-height: 650px;
}
</style>
